import request from "@/api/api";
import Vue from "vue";
import * as PostUrl from "@/api/PostUrl.js";

(function () {
  const urls = {};
  Object.keys(PostUrl).forEach(key => (PostUrl[key] instanceof Object) && (urls[PostUrl[key].url] = JSON.parse(JSON.stringify(PostUrl[key]))))
  const POST_TYPE = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    OPTIONS: 'OPTIONS',
  }
  const SUCCESS_CODES = ['0']
  const SUCCESS_TYPE = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE'
  }
  const MESSAGE_STATUS = {
    success: '$messageSuccess',
    error: '$messageError'
  }

  class ApiPost extends Vue {
    constructor() {
      super();
      let showError = true
      let showSuccess = false
      let headers = {}
      let regMsg = null
      let errorMsg = null
      let successMsgBag = null
      let errorMsgBag = null
      let dataNotEmpty = false //返回数据不能为空m,否则报错
      let dataForceObj = false //返回数据必须是object，否则返回{}
      let finallyCall = null
      let post = (urlData, params = {...urlData}.params, opts = {}, map = (object) => object) => {
        let url = urlData
        if (urlData instanceof Object) {
          url = urlData.url
          headers = {...headers, ...urlData.headers}
        }
        const ajaxFun = request(url, params, {headers, ...opts}).then(res => {
          if (SUCCESS_CODES.includes(String(res['code'])) || (opts.method === POST_TYPE.GET && !res.hasOwnProperty('code'))) {
            // printLog(urlData, params, headers, res, SUCCESS_TYPE.SUCCESS)
            if (showSuccess && res) {
              regMsg = regMsg || res['msg']
              if (successMsgBag) {
                this[errorMsgBag](regMsg)
              } else {
                this.$messageSuccess(regMsg)
              }
            }
            let data = typeof map === 'function' ? map(res) : res
            return (dataNotEmpty && data == null && !dataForceObj) ? Promise.reject(res) : (data == null && dataForceObj) ? Promise.resolve({}) : Promise.resolve(data)
          } else {
            printLog(urlData, params, headers, res, SUCCESS_TYPE.FAILURE)
            if (showError && res) {
              errorMsg = errorMsg || res['msg']
              if (errorMsgBag) {
                this[errorMsgBag](errorMsg)
              } else {
                this.$messageError(errorMsg)
              }
            }
            return Promise.reject(res)
          }
        }).catch(error => Promise.reject(error)).finally(() => {
          if (urls[urlData.url]) {//还原对象
            const copyUrlData = JSON.parse(JSON.stringify(urls[urlData.url]))
            Object.assign(urlData, copyUrlData)
          }
          typeof finallyCall === 'function' && finallyCall()
        })
        return ajaxFun
      }
      this.httpGet = (url, params = {}) => {
        return post(url, params, {method: POST_TYPE.GET})
      }
      this.httpPost = (url, params) => {
        return post(url, params, {method: POST_TYPE.POST})
      }
      this.httpGetForMap = (url, params, map = (object) => object.data) => {
        return post(url, params, {method: POST_TYPE.GET}, map)
      }
      this.httpPostForMap = (url, params, map = (object) => object.data) => {
        return post(url, params, {method: POST_TYPE.POST}, map)
      }
      this.httpOption = (url) => {
        return request(url, {}, {method: POST_TYPE.OPTIONS})
      }
      /**=================以下方法需要在 http方法之前调用=================**/
      this.hideErrorDialog = () => {
        showError = false
        return this
      }
      /**
       * @param msg 用来替换系统返回的 msg (type:string | function)
       * @returns {ApiPost}
       */
      this.showSuccessDialog = (msg) => {
        regMsg = typeof msg === 'function' ? msg() : typeof msg === 'string' ? msg : null
        showSuccess = true
        return this
      }
      /**
       * @param msg 用来替换系统返回的 msg (type:string | function)
       * @returns {ApiPost}
       */
      this.showErrorDialog = (msg) => {
        errorMsg = typeof msg === 'function' ? msg() : typeof msg === 'string' ? msg : null
        showError = true
        return this
      }
      this.setSuccessMsgBag = (key) => {
        if (MESSAGE_STATUS.hasOwnProperty(key)) {
          successMsgBag = MESSAGE_STATUS[key]
        }
        return this
      }
      this.setErrorMsgBag = (key) => {
        if (MESSAGE_STATUS.hasOwnProperty(key)) {
          errorMsgBag = MESSAGE_STATUS[key]
        }
        return this
      },
        this.dataNotNull = () => {
          dataNotEmpty = true
          return this
        }
      this.dataForceObject = () => {
        dataForceObj = true
        return this
      }
      this.setFinallyCall = (func) => {
        finallyCall = func
        return this
      }
      /**
       * @param header 设置header 如果在url对象中设置了，则会合并 (type:object | function)
       * @returns {ApiPost}
       */
      this.setHeaders = (header) => {
        if (typeof header === 'function') {
          headers = header()
        } else if (header instanceof Object) {
          headers = header
        }
        return this
      }
    }
  }

  function printLog(urlData, request, headers = {}, response, flag) {
    if (process.env.NODE_ENV === 'development') {
      const logData = {
        urlData: {...urlData},
        request,
        response,
      }
      if (Object.keys(headers).length) {
        logData.headers = headers
      }
      logData.urlData.url = process.env.BASE_API + logData.urlData.url
      const describe = urlData.describe || urlData.url
      let color = '#acff96'
      if (flag === SUCCESS_TYPE.SUCCESS) {
        console.log(`【${describe}】请求成功：`)
      } else if (flag === SUCCESS_TYPE.FAILURE) {
        console.log(`【${describe}】请求失败：`)
        color = '#e5e5e5'
      }
      console.dir(logData)
      // console.log('%o',logData)
      console.log('%c%s', `padding: 2px 4px;background: ${color};color: black;border-radius: 2px;`, JSON.stringify(logData));
    }
  }

  Vue.prototype.$apiPost = null
  Object.defineProperty(Vue.prototype, '$apiPost', {
    get() {
      return new ApiPost()
    }
  })
})()



// WEBPACK FOOTER //
// ./src/libs/AjaxPost.js